import { defineComponent as a, createElementBlock as r, createCommentVNode as d, unref as c, openBlock as l, createElementVNode as t, renderSlot as o } from "vue";
import { useIsEditable as m } from "../hooks/useIsEditable.js";
const p = {
  key: 0,
  class: "empty-state highlight-active",
  contenteditable: "false"
}, f = {
  class: "empty-state-icon",
  contenteditable: "false"
}, u = { contenteditable: "false" }, E = /* @__PURE__ */ a({
  __name: "EditorEmptyState",
  props: {
    editor: {}
  },
  setup(s) {
    const n = s, { isEditable: i } = m(n.editor);
    return (e, _) => c(i) ? (l(), r("div", p, [
      t("div", f, [
        o(e.$slots, "icon", {}, void 0, !0)
      ]),
      t("div", u, [
        o(e.$slots, "default", {}, void 0, !0)
      ])
    ])) : d("", !0);
  }
});
export {
  E as default
};
